<template>
  <span
    class="ds-spinner"
    :class="sizeClass"
    aria-hidden="true"
  />
</template>

<script>
const SIZES = ['sm', 'md']

export default {
  name: 'DsSpinner',
  props: {
    size: {
      type: String,
      default: 'sm',
      validator: value => SIZES.includes(value),
    },
  },
  computed: {
    // Namespaced, and falls back rather than trusting the prop: the validator only warns
    // in dev, so an unknown size would otherwise render a ring with no dimensions at all
    // — an invisible element instead of a wrong-sized one.
    sizeClass() {
      return `ds-spinner-${SIZES.includes(this.size) ? this.size : 'sm'}`
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/design-system/mixins';

// Decorative only: callers pair it with visible text, which is what a screen
// reader announces.
.ds-spinner {
  display: inline-block;
  flex-shrink: 0;
  border-style: solid;
  border-color: $c-border;
  border-top-color: $c-orange;
  border-radius: 999px;
  animation: ds-spin 0.7s linear infinite;

  &.ds-spinner-sm {
    width: 13px;
    height: 13px;
    border-width: 2px;
    vertical-align: -2px;
  }

  &.ds-spinner-md {
    width: 20px;
    height: 20px;
    border-width: 2.5px;
    vertical-align: -4px;
  }
}

// First reduced-motion handling in the app, established here because every future
// consumer inherits it. The ring still reads as a ring, it just stops spinning.
@media (prefers-reduced-motion: reduce) {
  .ds-spinner { animation: none; }
}

@keyframes ds-spin {
  to { transform: rotate(360deg); }
}
</style>
